// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"b1bab70c","461":"b1bab70c","717":"67c22600","907":"b1bab70c","984":"b1bab70c"}[chunkId] + ".chunk.css";
};